import React from "react";
import { connect, MapStateToProps } from "react-redux";

import { bridge } from "@multiweb/reactCore/bridge";
import {
    createGetBackgroundAttributeColor,
    getAttributeInfoByName,
    getConfigAttributeByName,
    getRecordById,
} from "@multiweb/reactCore/datasource";
import { IconCode } from "@multiweb/types/contracts";
import { IAppState } from "@multiweb/types/react";
import { createGetRecordTitleById, getInteractive } from "../../../selectors";
import { FrameAttributeSharedProps } from "../../../types";
import { AttributeComponent, AttributeProps } from "../types";

const { stringToEnumValue } = bridge;

export type ConnectedAttributeHOCProps = FrameAttributeSharedProps;

type StateProps = Pick<
    AttributeProps,
    "record" | "dataSourceAttribute" | "dataSourceAttributeInfo" | "backgroundAttributeColor" | "interactive"
>;

const createMapStateToProps: () => MapStateToProps<StateProps, ConnectedAttributeHOCProps, IAppState> = () => (
    state,
    { dataSourceKey, recordId, attributeName },
) => {
    const getBackgroundAttributeColor = createGetBackgroundAttributeColor();
    const getRecordTitleById = createGetRecordTitleById();

    return {
        record: getRecordById(state, { dataSourceKey, recordId }),
        dataSourceAttribute: getConfigAttributeByName(state, { dataSourceKey, attributeName }),
        dataSourceAttributeInfo: getAttributeInfoByName(state, { dataSourceKey, attributeName }),
        backgroundAttributeColor: getBackgroundAttributeColor(state, { dataSourceKey, attributeName, recordId }),
        interactive: getInteractive(state, dataSourceKey),
        title: getRecordTitleById(state, { dataSourceKey, attributeName, recordId }),
    };
};

/**
 * HOC pro propejení atributu do store.
 *
 * @param Attribute Komponenta pro attribute
 * @param enableBackgroundColor
 */
export const connectAttribute = (
    AttributeComponent: AttributeComponent,
) => {
    const ConnectedAttributeHOC: AttributeComponent = (props) => {
        return (
            <AttributeComponent {...props} iconCode={stringToEnumValue(IconCode, props.dataSourceAttribute?.iconName ?? "")} />
        );
    };

    return connect(createMapStateToProps)(ConnectedAttributeHOC);
};
